import {
  Building2,
  Briefcase,
  ClipboardList,
  Clock,
  Calendar,
  ClipboardCheck,
  FileBarChart,
  Bell,
  Users,
  UserCheck,
  FolderOpen,
  CheckSquare,
  Timer
} from 'lucide-react'
import { SideLink } from './sidelinks'

export const teamLeaderLinks: SideLink[] = [
  {
    title: 'Dashboard',
    href: '/team-leader/dashboard',
    icon: <Building2 size={18} />,
  },
  {
    title: 'Projects',
    href: '/team-leader/projects',
    icon: <Briefcase size={18} />,
    sub: [
      {
        title: 'Manage',
        href: '/team-leader/projects',
        icon: <FolderOpen size={18} />,
      }
    ]
  },
  {
    title: 'Tasks',
    href: '/team-leader/tasks',
    icon: <ClipboardList size={18} />,
    sub: [
      {
        title: 'Manage',
        href: '/team-leader/tasks',
        icon: <CheckSquare size={18} />,
      }
    ]
  },
  {
    title: 'Time Tracking',
    href: '/team-leader/time-tracking',
    icon: <Clock size={18} />,
    sub: [
      {
        title: 'Manage',
        href: '/team-leader/time-tracking',
        icon: <Timer size={18} />,
      }
    ]
  },
  {
    title: 'Team',
    href: '/team-leader',
    icon: <Users size={18} />,
    sub: [
      {
        title: 'Employees',
        href: '/team-leader/employees',
        icon: <UserCheck size={18} />,
      }
    ]
  },
  {
    title: 'Team Schedule',
    href: '/team-leader/team-schedule',
    icon: <Calendar size={18} />,
  },
  {
    title: 'Quality Inspections',
    href: '/team-leader/quality-inspections',
    icon: <ClipboardCheck size={18} />,
  },
  {
    title: 'Reports',
    href: '/team-leader/reports',
    icon: <FileBarChart size={18} />,
  },
  {
    title: 'Notifications',
    href: '/team-leader/notifications',
    icon: <Bell size={18} />,
  }
]